import AgendaW from './agendas';
import AgendaCheck from './agendasCheck';
import { decryptText } from '../../utils/encryptionUtils';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';

const Agenda = () => {
    const state: any = useSelector((state: RootState) => state.user);
    const decryptedString = decryptText(state.user.isCheckWeb);
    const isCheckWeb = decryptedString === 'true';

  return  isCheckWeb ? <AgendaCheck /> : < AgendaW/>;
};

export default Agenda;